import { render } from "./GreenSpinner.vue?vue&type=template&id=20e6d68a&scoped=true"
const script = {}

import "./GreenSpinner.vue?vue&type=style&index=0&id=20e6d68a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20e6d68a"

export default script